<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <router-link class="col04" to="/Order">我的订单<span class="plr5">/</span></router-link>
            <div class="now_page">订单详情</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="1" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="flex-box flex-between">
                    <div class="fs22 col04 fwb">订单详情</div>
                    <div class="back fs22 col12 cursor flex-box" @click="$router.go(-1)">返回</div>
                </div>
                <div class="box send_box mt25 mb25">
                    <div class="title_box flex-box fs20 col27 fwb">
                        <div class="flex-grow-1">收件人信息</div>
                        <!-- <div class="fs18 col12 underline">修改地址</div> -->
                        <div class="fs18 col12 log flex-box underline">查看物流</div>
                    </div>
                    <div class="detail_box">
                        <div class="flex-box shop fs20 col12 fwb mb15">***医疗美容机构</div>
                        <div class="flex-box fs20 col27 fwb mb10">
                            <div>上海市闵行区合川路3136号8幢东侧5楼B区</div>
                            <div class="default fs14 colf">默认</div>
                        </div>
                        <div class="fs18 fs27">百晓生 18100860000</div>
                    </div>
                </div>
                <div class="flex-box flex-between mb15">
                    <div class="fs16 col04">订单编号：1234567890123456</div>
                    <div class="fs18 col12">待付款</div>
                </div>
                <div class="box info_box mb25">
                    <div class="title_box flex-box fs18 col04 tc">
                        <div class="box1">商品</div>
                        <div class="box2">规格</div>
                        <div class="box3">单价(元)</div>
                        <div class="box4">数量</div>
                        <div class="flex-grow-1 tc">小计(元)</div>
                    </div>
                    <div class="goods_box flex-box fs18">
                        <div class="box1 flex-box">
                            <img src="../../../assets/static/images/invoice.png" class="pic" alt="">
                            <div class="flex-grow-1 pl30"><span class="fs14 colf">特价</span>3件装 | MEDIHEAL 美迪惠尔N.M.F针剂水库保
                            </div>
                        </div>
                        <div class="box2 tc">3支/盒</div>
                        <div class="box3 tc col90">50.00</div>
                        <div class="box4 tc col27">× 100</div>
                        <div class="flex-grow-1 tc coleb fwb">16900.00</div>
                    </div>
                </div>
                <div class="flex-box flex-between mb15">
                    <div class="fs16 col90">创建时间：2024.06.17 16:30</div>
                    <div class="fs20 col04">支付方式：<span class="col12">公对公付款</span></div>
                </div>
                <div class="flex-box flex-col-start">
                    <div class="flex-grow-1">
                        <div class="fs16 col90 mb15">创建时间：2024.06.17 16:30</div>
                        <div class="fs16 col90 mb15">创建时间：2024.06.17 16:30</div>
                    </div>
                    <!-- <div class="foot_btn resend flex-box flex-center fs20 fwb">重新上传试用报告</div>
                    <div class="foot_btn sure fs20 fwb">上传试用报告</div> -->
                    <div>
                        <div class="fs20 col04 mb10">已退还金额：<span class="coleb fwb">¥16900.00</span></div>
                        <div class="fs16 col90 tr">( 由原支付路径返还 )</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "订单详情-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {

        };
    },
    methods: {

    },
};
</script>

<style lang="less" scoped>
.back::before {
    content: "";
    display: block;
    width: 27px;
    height: 24px;
    background: url('/src/assets/static/icon/c_back.png') no-repeat center;
    background-size: 100%;
    margin-right: 10px;
}

.log::after {
    content: "";
    display: block;
    width: 15px;
    height: 15px;
    background: url('/src/assets/static/icon/c_continue.png') no-repeat center;
    background-size: 100%;
    margin-left: 6px;
}

.part_r {
    background: #fff;
    padding: 41px 44px 176px;

    .send_box {
        background: #FBFCFD;

        .title_box {
            height: 71px;
            border-bottom: 1px solid rgba(98, 134, 171, 0.4);
            padding-left: 24px;
            padding-right: 44px;

            &::before {
                content: "";
                display: block;
                width: 17px;
                height: 20px;
                margin-right: 14px;
                background: url('../../../assets/static/icon/c_send.png') no-repeat center;
                background-size: 100%;
            }
        }

        .detail_box {
            padding: 22px 100px 24px 55px;

            .shop {
                position: relative;

                &::before {
                    content: "";
                    display: block;
                    width: 16px;
                    height: 14px;
                    background: url('../../../assets/static/icon/c_send_shop.png') no-repeat center;
                    background-size: 100%;
                    position: absolute;
                    top: 10px;
                    left: -31px;
                }
            }

            .default {
                margin-left: 14px;
                width: 43px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                background: linear-gradient(117deg, #3D6CFE 0%, #4AC3FC 100%);
                border-radius: 4px;
                border: 1px solid;
                border-image: linear-gradient(196deg, rgba(255, 255, 255, 1), rgba(18, 117, 255, 0)) 1 1;
            }
        }
    }

    .info_box {
        border: 1px solid rgba(98, 134, 171, 0.3);

        .title_box {
            width: 100%;
            height: 68px;
            background: #FAFCFF;
        }

        .goods_box {
            width: 100%;
            height: 192px;
        }

        .box1 {
            width: 473px;

            .pic {
                width: 144px;
                height: 144px;
                background: #FFFFFF;
                border-radius: 8px;
                border: 1px solid rgba(98, 134, 171, 0.2);
                margin-left: 44px;
            }

            span {
                width: 43px;
                height: 20px;
                background: linear-gradient(153deg, #FF4D4D 0%, #FF652D 100%);
                border-radius: 5px;
                display: inline-block;
                line-height: 20px;
                text-align: center;
                margin-right: 10px;
            }
        }

        .box2 {
            width: 156px;
        }

        .box3 {
            width: 100px;
        }

        .box4 {
            width: 120px;
        }

    }

    .foot_btn {
        width: 228px;
        height: 60px;
        border-radius: 6px;
        border: 2px solid #D2D2D2;
        color: #434343;
        line-height: 56px;
        text-align: center;
        margin-left: 24px;
        cursor: pointer;

        &.sure {
            border-radius: 6px;
            background: #1275FF;
            border-color: #1275FF;
            color: #fff;
        }

        &.resend {
            width: 272px;
            color: #1275FF;

            &::before {
                content: "";
                display: block;
                width: 20.5px;
                height: 23px;
                background: url('../../../assets/static/icon/c_resend.png') no-repeat center;
                background-size: 100%;
                margin-right: 6px;
            }
        }
    }
}
</style>
